// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle-" + {"727":"e35f0bee2a985fad2dd9","798":"e7eda10e72ef3e320d41","890":"7362852f1b27f3c51d87"}[chunkId] + ".min.js";
};